<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useSseNotifications } from '@/composables/useSseNotifications'

const { t } = useI18n()
const { mandatoryQueue, confirmMandatory } = useSseNotifications()

const current = computed(() => mandatoryQueue.value[0] ?? null)
const visible = computed(() => current.value !== null)

const severityIcon: Record<string, string> = {
  info:   'pi pi-info-circle',
  warn:   'pi pi-exclamation-triangle',
  danger: 'pi pi-times-circle',
}

const severityColor: Record<string, string> = {
  info:   'var(--p-blue-500)',
  warn:   'var(--p-yellow-500)',
  danger: 'var(--p-red-500)',
}

function confirm() {
  if (current.value) confirmMandatory(current.value.id)
}
</script>

<template>
  <Dialog
    v-if="current"
    :visible="visible"
    :closable="false"
    :modal="true"
    :draggable="false"
    :close-on-escape="false"
    :style="{ width: '480px', maxWidth: '95vw' }"
    :pt="{ header: { style: 'display:none' } }"
  >
    <div class="snd-body">
      <div class="snd-icon-wrap">
        <i
          :class="severityIcon[current.severity] || 'pi pi-bell'"
          :style="{ color: severityColor[current.severity] || 'var(--p-blue-500)', fontSize: '2.5rem' }"
        />
      </div>
      <h3 class="snd-title">
        {{ current.titolo }}
      </h3>
      <p class="snd-message">
        {{ current.messaggio }}
      </p>
      <p
        v-if="mandatoryQueue.length > 1"
        class="snd-counter"
      >
        {{ t('layout.sistemaNotif.messaggioDi', { n: mandatoryQueue.length }, 'Messaggio 1 di {n}') }}
      </p>
      <Button
        :label="t('layout.sistemaNotif.confermato', 'Ho letto e confermato')"
        icon="pi pi-check"
        :severity="current.severity === 'danger' ? 'danger' : current.severity === 'warn' ? 'warn' : 'info'"
        class="snd-btn"
        @click="confirm"
      />
    </div>
  </Dialog>
</template>

<style scoped>
.snd-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1.5rem 1rem 0.5rem;
  gap: 0.75rem;
}

.snd-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  background: var(--p-surface-100);
}

.snd-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--p-text-color);
  margin: 0;
}

.snd-message {
  font-size: 0.9375rem;
  color: var(--p-text-color);
  line-height: 1.5;
  margin: 0;
  white-space: pre-wrap;
}

.snd-counter {
  font-size: 0.8rem;
  color: var(--p-text-muted-color);
  margin: 0;
}

.snd-btn {
  margin-top: 0.5rem;
  min-width: 200px;
}
</style>
